
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut, Home, User, BookOpen } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Menu } from 'lucide-react';
import { handleScrollReset } from '@/utils/navigationUtils';

interface HeaderMobileMenuProps {
  isLoggedIn: boolean;
  onLogout: () => void;
  isUserDashboard: boolean;
  getDashboardLink: () => string;
}

const HeaderMobileMenu: React.FC<HeaderMobileMenuProps> = ({
  isLoggedIn,
  onLogout,
  isUserDashboard,
  getDashboardLink,
}) => {
  return (
    <Sheet>
      <SheetTrigger className="md:hidden">
        <Menu className="h-6 w-6 text-white" />
      </SheetTrigger>
      <SheetContent side="right" className="sm:w-2/3 md:w-1/2 lg:w-1/3">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
          <SheetDescription>
            Explore our platform and manage your account.
          </SheetDescription>
        </SheetHeader>
        <div className="grid gap-4 py-4">
          <Link to="/" className="text-gray-600 hover:text-primary-blue block py-2" onClick={handleScrollReset}>
            <div className="flex items-center">
              <Home className="h-4 w-4 mr-2" />
              Home
            </div>
          </Link>
          <Link to="/pricing" className="text-gray-600 hover:text-primary-blue block py-2" onClick={handleScrollReset}>
            Pricing
          </Link>
          <Link to="/how-it-works" className="text-gray-600 hover:text-primary-blue block py-2" onClick={handleScrollReset}>
            Features
          </Link>
          <Link to="/faq" className="text-gray-600 hover:text-primary-blue block py-2" onClick={handleScrollReset}>
            FAQ
          </Link>
          {isLoggedIn ? (
            <>
              <Link to={getDashboardLink()} className="text-gray-600 hover:text-primary-blue block py-2" onClick={handleScrollReset}>
                <div className="flex items-center">
                  <User className="h-4 w-4 mr-2" />
                  Dashboard
                </div>
              </Link>
              {isUserDashboard && (
                <>
                  <Link to="/user/profile" className="text-gray-600 hover:text-primary-blue block py-2 pl-6" onClick={handleScrollReset}>
                    Profile
                  </Link>
                  <Link to="/user/payout-report" className="text-gray-600 hover:text-primary-blue block py-2 pl-6" onClick={handleScrollReset}>
                    Payout Report
                  </Link>
                  <Link to="/user/referral-tracking" className="text-gray-600 hover:text-primary-blue block py-2 pl-6" onClick={handleScrollReset}>
                    Referral Tracking
                  </Link>
                </>
              )}
              <Button variant="outline" size="sm" className="w-full" onClick={onLogout}>
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-gray-600 hover:text-primary-blue block py-2" onClick={handleScrollReset}>
                Login
              </Link>
              <Link to="/business-signup" className="block py-2" onClick={handleScrollReset}>
                <Button size="sm" className="w-full">Sign Up</Button>
              </Link>
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default HeaderMobileMenu;
